import React, { PureComponent } from 'react'

import { AppBar, Tab, Tabs } from '@material-ui/core'

export class RoutesTabsBase extends PureComponent {
  renderLoading = () => (
    <Tabs
      centered
      value={false}
      textColor='primary'
      indicatorColor='primary'
    >
      <Tab label='Загрузка' />
    </Tabs>
  )

  onTabChange = (e, index) => {
    const { routes, selectRoute, isPricesPage, fromUaRoutes, isRoutesPage } = this.props

    const displayedRoutes = isPricesPage || isRoutesPage
      ? fromUaRoutes
      : routes

    selectRoute(displayedRoutes[index])
  }

  renderRoutes = () => {
    const { routeId, isPricesPage, isRoutesPage } = this.props

    const routes = this.props.routes.filter(({ company }) => company === this.props.company)
    const fromUaRoutes = this.props.fromUaRoutes.filter(({ company }) => company === this.props.company)

    const displayedRoutes = isPricesPage || isRoutesPage
      ? fromUaRoutes
      : routes
    const index = displayedRoutes.findIndex(route => route.id === routeId)
    const position = isPricesPage || isRoutesPage

    return (
      <Tabs
        value={index === -1 ? false : index}
        centered={position}
        onChange={this.onTabChange}
        textColor='primary'
        scrollable={!position}
        indicatorColor='primary'
      >
        {displayedRoutes.map(({ id, label }) => <Tab label={label} key={id} />)}
      </Tabs>
    )
  }

  render() {
    const { classes, isLoading } = this.props

    return (
      <AppBar
        color='default'
        position='static'
        className={classes.container}
      >
        {isLoading
          ? this.renderLoading()
          : this.renderRoutes()}
      </AppBar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RoutesTabs/RoutesTabs.js